import { Notice } from '@/components/Modal';

/**
 * 아직 v2 로 옮기지 않은 화면 자리.
 *
 * 라우트를 지금 다 등록해 두는 이유는, 사내에서 공유된 URL 이 v2 로 넘어와서도 404 가 아니라
 * "아직 안 옮겼고 v1 에서 보라"는 안내로 이어져야 하기 때문이다.
 * 화면을 하나 이식할 때마다 `screens.tsx` 에서 이 자리를 실제 컴포넌트로 바꾼다.
 */
export function PendingPage({ label, v1Source }: { label: string; v1Source: string }) {
  return (
    <section className="card p-6 space-y-4" style={{ maxWidth: '640px' }}>
      <div>
        <h1 className="text-xl font-bold" style={{ color: 'var(--text-primary)' }}>{label}</h1>
        <p className="text-sm mt-1" style={{ color: 'var(--text-muted)' }}>
          아직 v2 로 이관하지 않은 화면입니다. 이 경로는 현재 v1 에서 운영 중입니다.
        </p>
      </div>

      <Notice>
        이관 예정 · v1 원본 <span style={{ fontFamily: 'monospace' }}>{v1Source}</span>
      </Notice>
    </section>
  );
}
